'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alpha = exports.gradient = undefined;

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gradient = exports.gradient = function gradient() {
  var angle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var size = arguments[1];
  var color = arguments[2];
  return 'linear-gradient(' + angle + 'deg, transparent, transparent ' + (size - 1) + 'px, ' + color + ' ' + (size - 1) + 'px)';
};

var alpha = exports.alpha = function alpha(val, a) {
  try {
    return (0, _chromaJs2.default)(val).alpha(a).css();
  } catch (e) {
    return val;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-x-ray/dist/util.js
// module id = 192
// module chunks = 35783957827783 64089156084587 91322373450782 114276838955818